import { Link } from "@tanstack/react-router";
import { ArrowLeft, Banknote, MapPin, HelpCircle, ShieldCheck } from "lucide-react";
import { useShopSettings, DEFAULT_SHOP_SETTINGS } from "@/hooks/useShopSettings";

export default function Payment() {
  const { data: settings } = useShopSettings();
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border/50">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="size-4" />
            Nazad
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-10 sm:py-16">
        {/* Title */}
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight mb-2">
          Plaćanje
        </h1>
        <p className="text-muted-foreground text-sm mb-10 sm:mb-14">
          Sve informacije o načinima plaćanja vaše narudžbe.
        </p>

        <div className="space-y-12 sm:space-y-16">
          {/* Section 1 — Express dostava */}
          <section>
            <div className="flex items-center gap-3 mb-6">
              <div className="size-10 rounded-xl bg-foreground flex items-center justify-center">
                <Banknote className="size-5 text-background" />
              </div>
              <h2 className="text-lg font-semibold">Express dostava</h2>
            </div>

            <div className="text-[15px] leading-relaxed text-foreground/80 space-y-4">
              <p>
                Sigurnost naših kupaca nam je uvijek prioritet zbog toga plaćanje narudžbi se vrši prilikom preuzimanja pošiljke od kurira.
              </p>
            </div>

            <div className="mt-6 bg-white rounded-xl border border-border/60 px-4 py-4 flex items-center gap-4">
              <div className="size-10 rounded-lg bg-emerald-50 flex items-center justify-center shrink-0">
                <ShieldCheck className="size-5 text-emerald-600" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-0.5">Način plaćanja</p>
                <p className="text-base font-semibold">Pouzeće — platite kuriru</p>
              </div>
            </div>
          </section>

          {/* Divider */}
          <div className="h-px bg-border/60" />

          {/* Section 2 — Lično preuzimanje */}
          <section>
            <div className="flex items-center gap-3 mb-6">
              <div className="size-10 rounded-xl bg-foreground flex items-center justify-center">
                <MapPin className="size-5 text-background" />
              </div>
              <h2 className="text-lg font-semibold">Lično preuzimanje</h2>
            </div>

            <div className="text-[15px] leading-relaxed text-foreground/80 space-y-4">
              <p>
                Boravite na područiju <strong>Općine Tešanj</strong> i želite lično preuzeti, u tom slučaju Vašu narudžbu plaćate prilikom preuzimanja na dogovorenoj adresi.
              </p>
            </div>
          </section>

          {/* Divider */}
          <div className="h-px bg-border/60" />

          {/* Section 3 — Pomoć */}
          <section>
            <div className="flex items-center gap-3 mb-6">
              <div className="size-10 rounded-xl bg-foreground flex items-center justify-center">
                <HelpCircle className="size-5 text-background" />
              </div>
              <h2 className="text-lg font-semibold">Kurir mi je naplatio više nego narudžba iznosi?</h2>
            </div>

            <div className="text-[15px] leading-relaxed text-foreground/80 space-y-4">
              <p>
                Bez brige, javite se korisničkoj podršci oni će Vam pomoći da sve nesporazume rješite.
              </p>
            </div>

            <div className="mt-6 bg-white rounded-xl border border-border/60 px-4 py-4">
              <p className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-2">Kontaktirajte nas</p>
              <div className="flex items-center gap-3 text-sm">
                <span className="font-medium">Facebook</span>
                <span className="text-border">·</span>
                <span className="font-medium">Instagram</span>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border/50 mt-10">
        <div className="max-w-3xl mx-auto px-4 py-8 text-center text-xs text-muted-foreground tracking-wide">
          {settings?.shop_name ?? DEFAULT_SHOP_SETTINGS.shop_name} · Bosna i Hercegovina
        </div>
      </footer>
    </div>
  );
}
